import Success from "components/Success";
import withAppProviders from "hocs/withAppProviders";
import { VERBIAGE_LABEL } from "utilities/constants";

export default withAppProviders({
  title: VERBIAGE_LABEL.ORDER_CONFIRMATION,
  offsets: 2,
  route: "/success",
})(Success);
